import { UpdateIcon } from "../../../images";
import { CustomButton } from "../../CustomButton";
import { AccountPlanModal } from "../../modal";
import { useState } from "react";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { useUpdateAccountPlanGenerationMutation } from "../../../../api";
import { AccountPlanStatus, PlaybookPlanNames } from "../../../../types/enums";
import { CircularProgress } from "@mui/material";
import { useAppSelector } from "../../../../hooks";
import { selectPermissions } from "../../../../features/permissionsSlice";

export const UpdateAccountsPlanBtn = ({
  campaign_id,
  hideButton = true,
  isSingleAccount,
  account_id,
  onClose,
  btnHeight = "36px",
  btnPadding = "6px",
}: {
  campaign_id: string;
  isSingleAccount?: boolean;
  account_id?: string;
  hideButton?: boolean;
  onClose?: () => void;
  btnHeight?: string;
  btnPadding?: string;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(hideButton);

  const { isAllowedEditGenerateReports } = useAppSelector(selectPermissions);

  const [updateAccountPlans, { isLoading }] =
    useUpdateAccountPlanGenerationMutation();

  const handleClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  const submitHandler = (
    account_ids: string[],
    include_all: boolean = false,
  ) => {
    updateAccountPlans({
      campaign_id,
      account_ids,
      include_all,
    })
      .unwrap()
      .then(handleClose)
      .catch((err) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title={"Something went wrong"}
          />,
        );
      });
  };

  const updateHandler = () => {
    if (isSingleAccount && account_id) {
      submitHandler([account_id]);
    } else {
      setIsOpen(true);
    }
  };

  return (
    <>
      {!hideButton && (
        <CustomButton
          onClick={updateHandler}
          variant="outlined"
          customColor="#FFFFFF"
          textColor="#1D3E70"
          type="button"
          customSize="fit"
          style={{ padding: btnPadding }}
          sx={{
            borderColor: "#FE8836",
            minWidth: "fit-content",
            height: btnHeight,
          }}
          disabled={isLoading || !isAllowedEditGenerateReports}
        >
          {isLoading ? (
            <CircularProgress size={24} sx={{ color: "#1C3C6C" }} />
          ) : (
            <UpdateIcon color={"#CB6D2B"} />
          )}
        </CustomButton>
      )}

      {isOpen && (
        <AccountPlanModal
          title={`Update ${PlaybookPlanNames.account_plans}`}
          description={`Which accounts would you like to update ${PlaybookPlanNames.account_plans} for?`}
          status_filter={AccountPlanStatus.needs_update}
          submitBtnText={`Update ${PlaybookPlanNames.account_plans}`}
          onClose={handleClose}
          isLoading={isLoading}
          onSubmit={submitHandler}
        />
      )}
    </>
  );
};
